<script lang="ts" setup>
defineOptions({
  name: 'LayoutSimple',
});
</script>

<template>
  <slot></slot>
</template>

<style lang="scss" scoped>
</style>
